const {
  appendPath,
  getValue
} = require('@truqc/content-path');
const {
  evaluateSource
} = require('../lib/evaluateSource');

/**
  * @function evalute - evaluate readContentValueBehavior
  */

const evaluate = async (source, content, parentContentPath, transientContext, nativeFunctions) => {
  const sourceContentPath = await evaluateSource(source.sourceContentPath, content, parentContentPath, transientContext, nativeFunctions);
  if (sourceContentPath === undefined) {
    return undefined;
  }
  const path = appendPath(parentContentPath, sourceContentPath);
  if (path === '/') {
    return content;
  }
  return getValue(path, content);
};
module.exports = {
  evaluate
};